
import { SearchService } from './../../../services/search.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { AuthService } from './../../../services/auth.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BookingService } from 'src/app/services/booking.service';

@Component({
  selector: 'app-rental-vehicle-not-available',
  templateUrl: './rental-vehicle-not-available.component.html',
  styleUrls: ['./rental-vehicle-not-available.component.css']
})
export class RentalVehicleNotAvailableComponent implements OnInit {

  faTimesCircle = faTimesCircle;
  msg: string = 'SorryRentalVehicleisnotavailableforthenewperiod';//defualt value

  constructor(

    private bookinService: BookingService, private searchService: SearchService, private bookingService: BookingService, private dialogRef: MatDialogRef<RentalVehicleNotAvailableComponent>,
    @Inject(MAT_DIALOG_DATA) private data, private router: Router, private formBuilder: FormBuilder, public translateService: TranslateService,) {

  }

  ngOnInit() {
    if (this.data != null && this.data.msg != null) {
      this.msg = this.data.msg;
    }
  }

  close(): void {
    this.dialogRef.close();
  }
  GoToSearchResults() {
    this.dialogRef.close();
    this.router.navigate(['./home']);
  }



}
